const LimitedPermission = () => {
  return [
    { label: "Randevu Takvimi", name: "appointment" },
    { label: "Randevu Görüntüleme", name: "appointment_visibility" },
    { label: "Adisyon Yönetimi", name: "sales" },
    { label: "Paket Yönetimi", name: "packet" },
    { label: "Stok Yönetimi", name: "stock" },
    { label: "Müşteri İşlemleri", name: "customer" },
    { label: "Müşteri Bilgileri", name: "customer_info" },
    { label: "Hizmet Yönetimi", name: "services" },
    { label: "SMS Yönetimi", name: "sms" },
    { label: "Muhasebe Yönetimi", name: "accounting" },
    { label: "Gelişmiş Raporlar", name: "income_expense" },
    { label: "Bakiye İşlemleri", name: "wallet" },
    { label: "Galeri Yönetimi", name: "gallery" },
    { label: "Sistem Ayarları", name: "system" },
  ];
};

export default LimitedPermission;
